import { ref, watchEffect } from "vue";
const useIntersectionObserver = (options) => {
  const { IntersectionObserver } = globalThis;
  const observer = ref();
  const observables = ref([]);
  const cleanObservers = () => {
    observables.value.forEach(({ element }) => {
      if (observer.value) {
        observer.value.unobserve(element);
      }
    });
    observer.value = void 0;
  };
  const prepareObservers = () => {
    if (IntersectionObserver) {
      cleanObservers();
      observer.value = new IntersectionObserver((baseEntries) => {
        const entries = baseEntries;
        entries.forEach((entry) => {
          observables.value.forEach(({ element, action }) => {
            if (element === entry.target && entry.isIntersecting) {
              action == null ? void 0 : action(entry);
            }
          });
        });
      }, options);
      observables.value.forEach(({ element }) => {
        var _a;
        (_a = observer.value) == null ? void 0 : _a.observe(element);
      });
    }
  };
  const onEffect = () => {
    prepareObservers();
  };
  const addIntersectionAction = (element, action) => {
    observables.value.push({
      element,
      action
    });
    prepareObservers();
  };
  watchEffect(() => onEffect);
  return {
    addIntersectionAction,
    observer
  };
};
export {
  useIntersectionObserver as default,
  useIntersectionObserver
};
//# sourceMappingURL=useIntersectionObserver.mjs.map
